<template>
  <div class="p-1 space-y-1" dir="rtl">
    <div class="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] space-y-2 w-[92vw] max-w-sm" aria-live="assertive"
         aria-atomic="true">
      <transition-group name="toast" tag="div">
        <div v-for="t in toasts" :key="t.id"
             class="rounded-md border shadow-md px-3 py-2 text-sm flex items-start gap-2"
             :class="t.type==='error' ? 'bg-rose-50 border-rose-200 text-rose-800' : 'bg-emerald-50 border-emerald-200 text-emerald-800'"
             role="alert">
          <div class="mt-[2px]">
            <span v-if="t.type==='error'">⚠️</span>
            <span v-else>✅</span>
          </div>
          <div class="flex-1 leading-5">{{ t.message }}</div>
          <button class="text-xs text-gray-500 hover:text-gray-700" @click="removeToast(t.id)">بستن</button>
        </div>
      </transition-group>
    </div>
    <section class="rounded-lg border border-gray-200 p-3 space-y-3 bg-white">
      <div class="flex items-center gap-2">
        <button
            style="max-width : 30px; height: 30px"
            @click="showMeta = !showMeta"
            class=" flex items-center justify-center  transition"
            :title="showMeta ? 'بستن اطلاعات پکیج' : 'نمایش اطلاعات پکیج'"
        >
          <span v-if="showMeta">
            <svg class="h-4 w-4 text-blue-800 rotate-180 transition-transform " viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 011.08 1.04l-4.24 4.25a.75.75 0 01-1.08 0l-4.24-4.25a.75.75 0 01.02-1.06z"/>
            </svg>
          </span>
          <span v-else>
            <svg class="h-4 w-4 text-blue-800 " viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 011.08 1.04l-4.24 4.25a.75.75 0 01-1.08 0l-4.24-4.25a.75.75 0 01.02-1.06z"/>
            </svg>
          </span>
        </button>

        <div class="space-y-0.5">
          <h1 class="text-sm font-semibold text-gray-600">مدیریت پکینگ {{ meta.title }}</h1>
          <p class="text-[10px] text-gray-600">شناسه پکینگ: {{ packageId }}</p>
        </div>
        <div class="left-1 flex items-center gap-2 justify-end">
          <button
              class="px-2.5 py-1.5 text-[10px] rounded-lg border border-gray-200 bg-gray-50 text-gray-700 hover:bg-gray-100"
              @click="reloadAll"
              :disabled="loading.meta || loading.items"
          >
            بازخوانی
          </button>
          <button
              class="px-3 py-1.5 text-[10px] rounded-lg font-semibold
               bg-emerald-600 text-white hover:bg-emerald-700
               disabled:bg-gray-300 disabled:text-gray-600 disabled:cursor-not-allowed
               shadow-sm"
              @click="saveMeta"
              :disabled="!metaDirty || saving.meta"
          >
            ثبت تغییرات پکیج
          </button>
        </div>
      </div>

      <transition name="collapse">
        <div v-show="showMeta" class="space-y-3 pt-1">
          <div class="grid md:grid-cols-12 gap-3">
            <div class="md:col-span-3">
              <label class="text-xs text-gray-700">عنوان</label>
              <input v-model.trim="meta.title" type="text"
                     class="w-full px-2 py-2 rounded-lg ring-1 ring-gray-200 focus:ring-emerald-400 text-sm"
                     placeholder="عنوان"/>
            </div>
            <div class="md:col-span-3">
              <label class="text-xs text-gray-700">شماره فاکتور</label>
              <input v-model.trim="meta.factor_number" type="text"
                     class="w-full px-2 py-2 rounded-lg ring-1 ring-gray-200 focus:ring-emerald-400 text-sm"
                     placeholder="شماره فاکتور"/>
            </div>
            <div class="md:col-span-3">
              <label class="text-xs text-gray-700">تاریخ ثبت</label>
              <input v-model="meta.registration_date" type="date"
                     class="w-full px-2 py-2 rounded-lg ring-1 ring-gray-200 focus:ring-emerald-400 text-sm"/>
            </div>
            <div class="md:col-span-3">
              <label class="text-xs text-gray-700">تامین‌کننده</label>
              <select v-model="meta.supplier" class="w-full px-2 py-2 rounded-lg ring-1 ring-gray-200 text-sm">
                <option :value="null">— انتخاب —</option>
                <option v-for="s in suppliers" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select>
            </div>
            <div class="md:col-span-12">
              <label class="text-xs text-gray-700">توضیحات</label>
              <textarea v-model.trim="meta.explanation" rows="2"
                        class="w-full px-2 py-2 rounded-lg ring-1 ring-gray-200 focus:ring-emerald-400 text-sm"
                        placeholder="توضیحات"></textarea>
            </div>
          </div>
        </div>
      </transition>

      <p v-show="showMeta" class="text-[9px] text-gray-500 pt-1">
        * در صورت تغییر ارز یا هزینه‌های ارسال، سمت سرور قیمت پایه ها بروز می‌شود.
      </p>
    </section>
    <section class="rounded-lg border border-gray-200 bg-white px-3 py-2 mt-3">
      <div class="flex items-center justify-between mb-1">
        <div>
          <div class="text-xs font-semibold text-gray-800">خلاصه مالی پکینگ</div>
        </div>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-5 gap-2 text-[9px]">
        <div class="flex items-center justify-between p-2 rounded-lg bg-gray-50 border border-gray-100">
          <div class="text-gray-600 font-bold ml-2 text-[10px]">کل :</div>
          <div class="flex items-center gap-2 text-gray-800">
            <span class="font-semibold">{{ summaryStats.planned_qty | toMoney }}</span>
            <span class="text-gray-400">عدد</span>
            <span class="font-semibold">{{ summaryStats.planned_value | toMoney}}</span>
            <span class="text-gray-400">تومان</span>
          </div>
        </div>
        <div class="flex items-center justify-between p-2 rounded-lg bg-rose-50 border border-rose-100">
          <div class="text-rose-700 font-bold ml-2 text-[10px]">مرجوعی:</div>
          <div class="flex items-center gap-2 text-rose-800">
            <span class="font-semibold">{{ fmt(summaryStats.returned_qty) }}</span>
            <span class="text-rose-500">عدد</span>
            <span class="font-semibold">{{ fmt(summaryStats.returned_value) }}</span>
            <span class="text-rose-500">تومان</span>
          </div>
        </div>
        <div class="flex items-center justify-between p-2 rounded-lg bg-emerald-50 border border-emerald-100">
          <div class="text-emerald-700 font-bold ml-2 text-[10px]">تحویل‌شده:</div>
          <div class="flex items-center gap-2 text-emerald-800">
            <span class="font-semibold">{{ summaryStats.delivered_qty | toMoney }}</span>
            <span class="text-emerald-500">عدد</span>
            <span class="font-semibold">{{ summaryStats.delivered_value | toMoney }}</span>
            <span class="text-emerald-500">تومان</span>
          </div>
        </div>
        <!-- مانده -->
        <div class="flex items-center justify-between p-2 rounded-lg bg-amber-50 border border-amber-100">
          <div class="text-amber-700 font-bold ml-2 text-[10px]">مانده:</div>
          <div class="flex items-center gap-2 text-amber-800">
            <span class="font-semibold">{{ summaryStats.remaining_qty | toMoney }}</span>
            <span class="text-amber-500">عدد</span>
            <span class="font-semibold">{{ summaryStats.remaining_value | toMoney }}</span>
            <span class="text-amber-500">تومان</span>
          </div>
        </div>

        <!-- درصد تحویل -->
        <div class="flex items-center justify-between p-2 rounded-lg bg-indigo-50 border border-indigo-100">
          <div class="text-indigo-700 font-bold ml-2 text-[10px]">درصد تحویل:</div>
          <div class="text-indigo-700 font-bold ">
            <span class="text-[15px]">{{ summaryStats.delivered_percent }}</span>
            <span class="text-[12px]">٪</span>
          </div>
        </div>
      </div>
    </section>

    <section class="rounded-lg border border-gray-200 overflow-hidden bg-white mt-3">
      <div class="flex bg-gray-white justify-between items-center  pr-3 py-2">
        <button
            style="max-width : 30px; height: 30px"
            @click="toggleItemsCollapse"
            class=" flex items-center justify-center  text-white  transition"
            :title="showItems ? 'بستن ویرایش ردیف‌ها' : 'نمایش ویرایش ردیف‌ها'"
        >
          <span v-if="showItems">
            <svg class="h-4 w-4 text-blue-800 rotate-180 transition-transform " viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 011.08 1.04l-4.24 4.25a.75.75 0 01-1.08 0l-4.24-4.25a.75.75 0 01.02-1.06z"/>
            </svg>
          </span>
          <span v-else>
            <svg class="h-4 w-4 text-blue-800 " viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 011.08 1.04l-4.24 4.25a.75.75 0 01-1.08 0l-4.24-4.25a.75.75 0 01.02-1.06z"/>
            </svg>
          </span>
        </button>

        <div @click="toggleItemsCollapse"  class="px-2 py-2 cursor-pointer mr-3 text-sm font-semibold text-gray-600">آیتم‌های پکیج</div>
        <input v-if="showItems" type="text" v-model.trim="skuSearch" @input="debouncedLoadItems" placeholder="جست‌وجو"
               class="px-2 py-2 rounded ring-1 ring-gray-300 bg-gray-100 text-gray-800 text-xs placeholder-gray-400"/>
        <div class="flex items-center gap-2 px-2 left-1 justify-end">
          <button
              class="px-2 py-1 text-xs rounded-md bg-blue-500 text-white hover:bg-blue-600"
              @click="openGenerateSkuConfirm"
              :disabled="itemsWithoutSkuCount === 0 || generatingSku"
          >
            🎲 تولید SKU برای آیتم‌های خالی ({{ itemsWithoutSkuCount }})
          </button>
          <button class="px-2 py-1 text-xs rounded-md bg-purple-500 text-white hover:bg-purple-600" @click="openBulkProfitModal"
          >تغییر دسته‌جمعی حاشیه سود
          </button>
          <button class="px-2 py-1 text-xs rounded-md bg-cyan-600 text-white hover:bg-cyan-700" @click="openBulkMinInventoryModal"
          >تعیین حداقل موجودی گروهی
          </button>
          <button v-if="!selectionMode" class="px-2 py-1 text-xs rounded-md bg-indigo-700 text-white hover:bg-indigo-600"
                  @click="toggleSelectionMode(true)">شروع یک پارچه سازی گروه
          </button>
          <template v-else>
            <button class="px-2 py-1 text-xs rounded bg-rose-800 text-rose-100 ring-1 ring-rose-700"
                    @click="toggleSelectionMode(false)">خروج از ویرایش گروهی
            </button>
            <button v-if="selectedIds.length"
                    class="px-2  py-1 text-xs rounded-md bg-emerald-700 text-white hover:bg-emerald-600"
                    @click="openVariationModalBulk">ثبت متغیر گروهی
            </button>
            <button v-if="selectedIds.length"
                    class="px-2  py-1 text-xs rounded-md bg-cyan-700 text-white hover:bg-cyan-500"
                    @click="openColorModalBulk">ثبت رنگ گروهی
            </button>
            <span v-else class="text-[10px] text-gray-300">از جدول انتخاب کن…</span>
          </template>
        </div>
      </div>

      <transition name="collapse">
        <div v-show="showItems">
          <div class="overflow-auto max-h-[65vh]">
            <table class="min-w-full text-sm text-right">
              <thead class="bg-gray-700 text-gray-100 sticky top-0 z-20">
              <tr>
                <th v-if="selectionMode" class=" font-thin text-center w-8">
                  <input type="checkbox" :checked="isAllSelected" @change="toggleSelectAll"/>
                </th>
                <th class="text-[8px] text-center" >تصویر</th>
                <th class="text-[8px] text-center">محصول</th>
                <th class="text-[8px] text-center">رنگ</th>
                <th class="text-[8px] text-center" >SKU</th>
                <th class="text-[8px] text-center" >نوع</th>
                <th class="text-[8px] text-center" >نام</th>
                <th class="text-[8px] text-center" >تعداد کل</th>
                <th class="text-[8px] text-center" >قیمت مصرف</th>
                <th class="text-[8px] text-center" >قیمت خرید</th>
                <th class="text-[8px] text-center" >نوع سود</th>
                <th class="text-[8px] text-center" >حاشیه سود</th>
                <th class="text-[8px] text-center" >قیمت فروش</th>
                <th class="text-[8px] text-center" ></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(it, idx) in sortedItems" :key="it.item_id"
                  class="border-t transition-colors cursor-pointer"
                  :class="rowClasses(it, idx)"
                  :style="rowStyle(it, idx)"
              >
                <td v-if="selectionMode" class="text-center" @click.stop>
                  <input type="checkbox" :value="it.item_id" v-model="selectedIds"/>
                </td>
                <td class="td text-center">
                  <div class="w-12 h-12 rounded-lg bg-gray-100 border overflow-hidden flex items-center justify-center">
                    <img v-if="it.image" :src="img_source(it.image)" class="w-full h-full object-cover"
                         @click.stop="openImagePreview(img_source(it.image))"/>
                    <span v-else class="text-[10px] text-gray-400">No Image</span>
                  </div>
                </td>

                <!-- بعد از سلول SKU، قبل از سلول نوع -->
                <td class="td text-center items-center">
                  <div v-if="it.product.id" class="flex items-center justify-center gap-1">
                    <div class="w-8 h-8 rounded bg-gray-100 border overflow-hidden flex-shrink-0">
                      <img v-if="it.product.image" :src="img_source(it.product.image)" class="w-full h-full object-cover" @click.stop="openImagePreview(img_source(it.product.image))"/>
                      <span v-else class="text-[6px] text-gray-400">بدون عکس</span>
                    </div>
                    <span class="text-[8px] truncate max-w-[80px]">{{ it.product.name }}</span>
                  </div>

                  <div v-else-if="it.similar_product.length > 0" class="flex justify-center">
                    <button
                        class="px-2 py-1 text-[9px] font-medium rounded bg-purple-100 text-purple-700 border border-purple-300 hover:bg-purple-200"
                        @click.stop="openSimilarProductsModal(it)"
                    >
                      {{ it.similar_product.length }} محصول مشابه
                    </button>
                  </div>

                  <div v-else class="text-[9px] font-medium text-center items-center text-blue-500">
                    محصول جدید
                  </div>
                </td>

                <td v-if="it.color[0]"  class="td text-center items-center cursor-pointer" @click="openColorModal(it)">
                  <div class="flex items-center justify-center gap-1">
                    <span class="text-[8px] truncate max-w-[80px] text-blue-700">دارای رنگ</span>
                  </div>
                </td>
                <td v-else class="td text-center items-center cursor-pointer" @click="openColorModal(it)">
                  <div class="text-[9px] font-medium text-center items-center text-blue-100 bg-blue-700 rounded-full">
                    !
                  </div>
                </td>
                <td class="td text-center">
                  <div v-if="editRow.id===it.item_id && editRow.mode==='sku'"
                       class="flex items-center gap-2 justify-center">
                    <input v-model.trim="editRow.newSku" type="text"
                           class="px-2 py-1 rounded ring-2 focus:ring-emerald-400 text-xs "/>
                    <button
                        class="px-2 py-1 rounded-md bg-blue-500 text-white text-sm hover:bg-blue-600"
                        @click="generateSku"
                        title="تولید SKU تصادفی"
                    >
                      🎲 تولید
                    </button>
                    <button
                        class="px-2 py-1 rounded-md bg-emerald-600 text-white text-sm disabled:bg-gray-400"
                        @click="commitSku(it)"
                    >
                      ذخیره
                    </button>
                    <button
                        class="px-2 py-1 rounded-md bg-gray-100 text-gray-700 text-sm"
                        @click="resetEdit"
                    >
                      انصراف
                    </button>
                  </div>
                  <div v-else class="flex items-center gap-2 justify-center">
                    <span class=" text-sm">{{ it.sku || '-' }}</span>
                    <button class="text-xs px-1 py-0.5 rounded ring-1 ring-gray-300 text-gray-700 bg-white/80"
                            @click.stop="beginEditSku(it)" title="ویرایش SKU">
                      ✎
                    </button>
                  </div>
                </td>
                <!-- Type -->
                <td class="td text-center" @click.stop="selectItemTypeForChange(it)">
              <span class="px-2 py-0.5 rounded-full text-[10px] border cursor-pointer"
                    :class="it.type==='variation' ? 'bg-purple-500 text-purple-50 border-purple-400' : 'bg-pink-500 text-pink-50 border-pink-400'">
                {{ it.type === 'variation' ? 'متغیر' : 'ساده' }}
              </span>
                </td>

                <!-- Name inline -->
                <td class="td items-center text-center justify-center">
                  <div v-if="editRow.id===it.item_id && editRow.mode==='name'" class="flex items-center text-center justify-center gap-2">
                    <input v-model.trim="editRow.newName" type="text"
                           class="w-full px-2 py-1 rounded ring-2 focus:ring-emerald-400 text-xs"/>
                    <button
                        class="px-2 py-1 rounded-md bg-emerald-600 text-white text-sm disabled:bg-gray-400"
                        @click="commitName(it)"
                    >
                      ذخیره
                    </button>
                    <button
                        class="px-2 py-1 rounded-md bg-gray-100 text-gray-700 text-sm"
                        @click="resetEdit"
                    >
                      انصراف
                    </button>
                  </div>
                  <div v-else class="flex items-center text-center justify-center gap-2   text-[8px]">
                      <span class=" font-semibold text-[8px]" v-if="it.variation_of_product_name">
                        {{it.variation_of_product_name}}
                      </span>
                    <br>
                    <span  class="  font-thin text-[7px]" v-if="it.variation_of_product_name">متغیر : </span>
                    {{ it.name }}
                    <button class="text-xs px-1 py-0.5 rounded ring-1 ring-gray-300 text-gray-700 bg-white/80"
                            @click.stop="beginEditName(it)" title="ویرایش نام">✎
                    </button>
                  </div>
                </td>

                <td class="td text-center">
                  <div v-if="editRow.id===it.item_id && editRow.mode==='planned'"
                       class="flex items-center gap-2 justify-center">
                    <input v-model.number="editRow.newPlanned" type="number" min="0"
                           class="w-24 px-2 py-1 rounded ring-2 focus:ring-emerald-400 text-xs text-center"/>
                    <button
                        class="px-2 py-1 rounded-md bg-emerald-600 text-white text-sm disabled:bg-gray-400"
                        @click="commitPlanned(it)"
                    >
                      ذخیره
                    </button>
                    <button
                        class="px-2 py-1 rounded-md bg-gray-100 text-gray-700 text-sm"
                        @click="resetEdit"
                    >
                      انصراف
                    </button>
                  </div>
                  <div v-else class="flex items-center gap-2 justify-center">
                    <span class="text-[11px]">{{ it.planned | toMoney }}</span>
                    <span class="text-[7px] mr-1">عدد</span>
                    <button class="text-xs px-1 py-0.5 rounded ring-1 ring-gray-300 text-gray-700 bg-white/80"
                            @click.stop="beginEditPlanned(it)" title="ویرایش تعداد">✎
                    </button>
                  </div>
                </td>

                <td class="td text-center">
                  <span class="text-[11px]">{{ it.regular_price | toMoney }}</span>
                  <span class="text-[7px] mr-1">تومان</span>

                </td>
                <td class="td text-center">
                  <div v-if="editRow.id===it.item_id && editRow.mode==='regular'"
                       class="flex items-center gap-2 justify-center">
                    <cleave-money
                        v-model.number="editRow.newRegularPrice"
                        currency-unit="تومان"
                        label=" "
                    ></cleave-money>
                    <button
                        class="px-2 py-1 rounded-md bg-emerald-600 text-white text-sm disabled:bg-gray-400"
                        @click="commitRegular(it)"
                    >
                      ذخیره
                    </button>
                    <button
                        class="px-2 py-1 rounded-md bg-gray-100 text-gray-700 text-sm"
                        @click="resetEdit"
                    >
                      انصراف
                    </button>
                  </div>

                  <div class="flex justify-center items-center gap-1" v-else>
                    <span class="text-[11px]">{{ it.price | toMoney }}</span>
                    <span class="text-[7px]">تومان</span>
                    <span
                        v-if="it.regular_price < it.price"
                        class="text-[10px] text-red-500 font-bold bg-red-50 px-1.5 py-0.5 rounded-md"
                    >
                        {{ Math.round(((it.regular_price - it.price) / it.regular_price) * 100) }}٪-
                    </span>
                    <span
                        v-else
                        class="text-[10px] text-blue-500 font-bold bg-blue-50 px-1.5 py-0.5 rounded-md"
                    >
                        {{ Math.round(((it.regular_price - it.price) / it.regular_price) * 100) }}٪-
                      </span>
                    <button class="text-xs px-1 py-0.5 rounded ring-1 ring-gray-300 text-gray-700 bg-white/80"
                            @click.stop="beginEditRegular(it)" title="ویرایش">✎
                    </button>

                  </div>
                </td>
                <td class="td text-center">
                  <span class="px-2 py-0.5 rounded bg-gray-50 ring-1 ring-gray-200 text-[10px]">
                    {{
                      it.profit_type === 'percent'
                          ? 'درصدی'
                          : it.profit_type === 'amount'
                              ? 'مبلغی'
                              : '-'
                    }}
                  </span>
                </td>

                <!-- Profit margin -->
                <td class="td text-center">
                  <span>{{ it.profit_margin != null ? it.profit_margin : '-' }}</span>
                </td>

                <td class="td text-center text-[11px]">
                  {{it.final_amount | toMoney}}
                  <span class="text-[7px] mr-1">تومان</span>

                </td>

                <td class="td justify-end">
                  <div class="flex items-center justify-end gap-1 pl-1">
                    <button class="px-2 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700"
                            @click.stop="openPriceModal(it)">تغییر قیمت
                    </button>
                    <button class="px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                            @click.stop="openSplitModal(it)">متغیر سازی
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="!items.length && !loading.items">
                <td :colspan="selectionMode ? 15 : 14"
                    class="td text-center text-gray-400">
                  آیتمی یافت نشد
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </transition>
    </section>

    <section class="rounded-lg border border-gray-200 overflow-hidden bg-white mt-3">

      <div class="flex bg-gray-white justify-between items-center cursor-pointer pr-3 py-2" @click="showRemainingOnlyStats = !showRemainingOnlyStats">
        <button
            style="max-width : 30px; height: 30px"
            class=" flex items-center justify-center  text-white  transition"
            :title="showRemainingOnlyStats ? 'آیتم‌های مانده‌دار ها' : 'آیتم‌های مانده‌دار ها'"
        >
          <span v-if="showRemainingOnlyStats">
            <svg class="h-4 w-4 text-blue-800 rotate-180 transition-transform " viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 011.08 1.04l-4.24 4.25a.75.75 0 01-1.08 0l-4.24-4.25a.75.75 0 01.02-1.06z"/>
            </svg>
          </span>
          <span v-else>
            <svg class="h-4 w-4 text-blue-800 " viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 011.08 1.04l-4.24 4.25a.75.75 0 01-1.08 0l-4.24-4.25a.75.75 0 01.02-1.06z"/>
            </svg>
          </span>
        </button>

        <div
             class=" cursor-pointer px-2 py-2  mr-3 text-sm font-semibold text-gray-600"> مانده‌</div>
        <div class="flex items-center gap-2 px-2 left-1 justify-end">
        </div>
      </div>

      <transition name="collapse">
        <div v-show="showRemainingOnlyStats">
          <div class="overflow-auto max-h-[60vh]">
            <table class="min-w-full text-[9px] text-right">
              <thead class="bg-gray-700 text-gray-100 sticky top-0 z-10">
              <tr>
                <th class="px-2 py-1 text-center">تصویر</th>
                <th class="px-2 py-1 text-center">SKU</th>
                <th class="px-2 py-1 text-right">نام</th>
                <th class="text-[8px] text-center">رنگ</th>
                <th class="text-[8px] text-center">قیمت پایه </th>
                <th class="px-2 py-1 text-center">تعداد کل</th>
                <th class="px-2 py-1 text-center">مبلغ کل</th>

                <th class="px-2 py-1 text-center">تعداد تحویل</th>
                <th class="px-2 py-1 text-center">مبلغ تحویل</th>
                <th class="px-2 py-1 text-center">تعداد مرجوع</th>
                <th class="px-2 py-1 text-center">مبلغ مرجوع</th>

                <th class="px-2 py-1 text-center">تعداد مانده</th>
                <th class="px-2 py-1 text-center">مبلغ مانده</th>
                <th class="px-2 py-1 text-center">عملیات</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="it in remainingOnlyStatsItems" :key="it.item_id" class="border-t hover:bg-gray-50">
                <td class="td text-center">
                  <div class="w-12 h-12 rounded-lg bg-gray-100 border overflow-hidden flex items-center justify-center">
                    <img v-if="it.image" :src="img_source(it.image)" class="w-full h-full object-cover"
                         @click.stop="openImagePreview(img_source(it.image))"/>
                    <span v-else class="text-[10px] text-gray-400">No Image</span>
                  </div>
                </td>

                <!-- SKU -->
                <td class="px-2 py-1 text-center  text-sm text-gray-700">
              <span class="px-2 py-0.5 inline-block">
                {{ it.sku || '-' }}
              </span>
                </td>

                <!-- نام -->
                <td class="px-2 py-1 text-gray-700 truncate max-w-[200px]">
                      <span class=" font-bold text-[12px]" v-if="it.variation_of_product_name">
                        {{it.variation_of_product_name}}
                      </span>
                  <br>
                  <span  class=" font-bold text-[8px]" v-if="it.variation_of_product_name">متغیر : </span>
                  {{ it.name }}
                </td>
                <td class="td text-center items-center">
                  <div v-if="it.color.id" class="flex items-center justify-center gap-1">
                    <span class="text-[8px] truncate max-w-[80px]">{{ it.color.name }}</span>
                  </div>

                  <div v-else class="text-[9px] font-medium text-center items-center text-blue-500">
                    -
                  </div>
                </td>

                <td class="td text-center">
                  <span class=" font-semibold">
                    {{ baseCost(it) | toMoney }}
                    <span class="text-[8px] mr-1">تومان</span>
                  </span>
                </td>
                <td class="px-2 py-1 text-center text-gray-800">
                  {{ it.planned || 0 }}
                  <span class="text-[8px] mr-1">عدد</span>

                </td>
                <td class="px-2 py-1 text-center text-gray-600">
                  {{ it.planned_value  | toMoney  }}
                  <span class="text-[8px] mr-1">تومان</span>

                </td>

                <td class="px-2 py-1 text-center text-emerald-700">
                  {{ it.delivered_to_date || 0 }}
                  <span class="text-[8px] mr-1">عدد</span>
                </td>
                <td class="px-2 py-1 text-center text-emerald-700">
                  {{ it.delivered_value | toMoney }}
                  <span class="text-[8px] mr-1">تومان</span>
                </td>

                <td class="px-2 py-1 text-center text-rose-700">
                  {{ returnedQty(it) || 0 }}
                  <span class="text-[8px] mr-1">عدد</span>
                </td>

                <td class="px-2 py-1 text-center text-rose-700">
                  {{ (baseCost(it) * returnedQty(it)) | toMoney }}
                  <span class="text-[8px] mr-1">تومان</span>
                </td>
                <td class="px-2 py-1 text-center text-amber-700">
                  {{ it.remaining || 0 }}
                  <span class="text-[8px] mr-1">عدد</span>
                </td>
                <td class="px-2 py-1 text-center text-amber-700">
                  {{ it.remaining_value | toMoney }}
                  <span class="text-[8px] mr-1">تومان</span>
                </td>
                <td class="px-2 py-1 text-center">
                  <button
                      class="px-2 py-1 text-[9px] rounded bg-rose-600 text-white hover:bg-rose-700 disabled:bg-gray-300"
                      @click="markRemainingAsReturned(it)"
                      :disabled="remainingEffective(it) <= 0"
                  >
                    ثبت مرجوعی مانده
                  </button>
                </td>

              </tr>

              <tr v-if="!filteredStatsItems.length">
                <td colspan="9" class="px-2 py-2 text-center text-[9px] text-gray-400">
                  تحویل تکمیل است.
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </transition>
    </section>

    <section class="rounded-lg border border-gray-200 overflow-hidden bg-white mt-3">

      <div class="flex bg-gray-white justify-between items-center  pr-3 py-2">
        <button
            style="max-width : 30px; height: 30px"
            @click="toggleItemStatsCollapse"
            class=" flex items-center justify-center  text-white  transition"
            :title="showItemStats ? 'بستن تحویل ها' : 'نمایش تحویل ها'"
        >
          <span v-if="showItemStats">
            <svg class="h-4 w-4 text-blue-800 rotate-180 transition-transform " viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 011.08 1.04l-4.24 4.25a.75.75 0 01-1.08 0l-4.24-4.25a.75.75 0 01.02-1.06z"/>
            </svg>
          </span>
          <span v-else>
            <svg class="h-4 w-4 text-blue-800 " viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 011.08 1.04l-4.24 4.25a.75.75 0 01-1.08 0l-4.24-4.25a.75.75 0 01.02-1.06z"/>
            </svg>
          </span>
        </button>

        <div @click="toggleItemStatsCollapse"  class=" cursor-pointer px-2 py-2  mr-3 text-sm font-semibold text-gray-600">وضعیت تحویل</div>
        <input v-if="showItemStats" type="text" v-model.trim="itemStatsSkuSearch" @input="debouncedLoadItems" placeholder="جست‌وجو "
               class="px-2 py-2 rounded ring-1 ring-gray-300 bg-gray-100 text-gray-800 text-xs placeholder-gray-400"/>
        <div class="flex items-center gap-2 px-2 left-1 justify-end">
        </div>
      </div>

      <transition name="collapse">
        <div v-show="showItemStats">
          <div class="overflow-auto max-h-[60vh]">
            <table class="min-w-full text-[9px] text-right">
              <thead class="bg-gray-700 text-gray-100 sticky top-0 z-10">
              <tr>
                <th class="px-2 py-1 text-center">تصویر</th>
                <th class="px-2 py-1 text-center">SKU</th>
                <th class="px-2 py-1 text-right">نام</th>
                <th class="text-[8px] text-center">قیمت پایه </th>
                <th class="px-2 py-1 text-center">تعداد کل</th>
                <th class="px-2 py-1 text-center">مبلغ کل</th>
                <th class="px-2 py-1 text-center">تعداد تحویل</th>
                <th class="px-2 py-1 text-center">مبلغ تحویل</th>
                <th class="px-2 py-1 text-center">تعداد مرجوع</th>
                <th class="px-2 py-1 text-center">مبلغ مرجوع</th>
                <th class="px-2 py-1 text-center">تعداد مانده</th>
                <th class="px-2 py-1 text-center">مبلغ مانده</th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(it) in itemsForStats"
                  :key="it.item_id"
                  class="border-t border-gray-100 hover:bg-gray-50 transition-colors"
                  :class="remainingEffective(it) <= 0 ? 'bg-emerald-100' : ''"
              >
                <td class="td text-center">
                  <div class="w-12 h-12 rounded-lg bg-gray-100 border overflow-hidden flex items-center justify-center">
                    <img v-if="it.image" :src="img_source(it.image)" class="w-full h-full object-cover"
                         @click.stop="openImagePreview(img_source(it.image))"/>
                    <span v-else class="text-[10px] text-gray-400">No Image</span>
                  </div>
                </td>

                <!-- SKU -->
                <td class="px-2 py-1 text-center  text-sm text-gray-700">
              <span class="px-2 py-0.5 inline-block">
                {{ it.sku || '-' }}
              </span>
                </td>

                <!-- نام -->
                <td class="px-2 py-1 text-gray-700 truncate max-w-[200px]">
                      <span class=" font-bold text-[12px]" v-if="it.variation_of_product_name">
                        {{it.variation_of_product_name}}
                      </span>
                  <br>
                  <span  class=" font-bold text-[8px]" v-if="it.variation_of_product_name">متغیر : </span>
                  {{ it.name }}
                </td>

                <td class="td text-center">
                  <span class=" font-semibold">
                    {{ baseCost(it) | toMoney }}
                    <span class="text-[8px] mr-1">تومان</span>
                  </span>
                </td>
                <td class="px-2 py-1 text-center text-gray-800">
                  {{ it.planned || 0 }}
                  <span class="text-[8px] mr-1">عدد</span>

                </td>
                <td class="px-2 py-1 text-center text-gray-600">
                  {{ it.planned_value  | toMoney  }}
                  <span class="text-[8px] mr-1">تومان</span>

                </td>

                <td class="px-2 py-1 text-center text-emerald-700">
                  {{ it.delivered_to_date || 0 }}
                  <span class="text-[8px] mr-1">عدد</span>
                </td>
                <!-- تحویل‌شده: مبلغ -->
                <td class="px-2 py-1 text-center text-emerald-700">
                  {{ it.delivered_value | toMoney }}
                  <span class="text-[8px] mr-1">تومان</span>
                </td>

                <td class="px-2 py-1 text-center text-rose-700">
                  {{ returnedQty(it) || 0 }}
                  <span class="text-[8px] mr-1">عدد</span>
                </td>
                <td class="px-2 py-1 text-center text-rose-700">
                  {{ (baseCost(it) * returnedQty(it)) | toMoney }}
                  <span class="text-[8px] mr-1">تومان</span>
                </td>
                <td class="px-2 py-1 text-center text-amber-700">
                  {{ remainingEffective(it) || 0 }}
                  <span class="text-[8px] mr-1">عدد</span>
                </td>
                <td class="px-2 py-1 text-center text-amber-700">
                  {{ (baseCost(it) * remainingEffective(it)) | toMoney }}
                  <span class="text-[8px] mr-1">تومان</span>
                </td>
              </tr>

              <tr v-if="!filteredStatsItems.length">
                <td colspan="9" class="px-2 py-2 text-center text-[9px] text-gray-400">
                  آیتمی برای نمایش موجود نیست.
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </transition>
    </section>

    <section class="rounded-2xl border border-gray-200 bg-white px-3 py-3 space-y-3 mt-3">
      <div class="flex items-center justify-between">
        <div class="ml-5">
          <div class="text-xs font-semibold text-gray-800">نمای وضعیت پکینگ</div>
        </div>
        <div class="flex items-center gap-2 text-[8px] text-gray-500">
          <div class="w-2 h-2 rounded-full bg-emerald-500"></div><span>تحویل‌شده</span>
          <div class="w-2 h-2 rounded-full bg-amber-400"></div><span>مانده</span>
        </div>
      </div>

      <div class="space-y-1">
        <div class="flex items-center justify-between text-[8px] text-gray-600">
          <span>پیشرفت بر اساس تعداد</span>
          <span>
        {{ fmt(summaryStats.delivered_qty) }} / {{ fmt(summaryStats.planned_qty) }} عدد
        ({{ overallProgress.qty_percent }}٪)
      </span>
        </div>
        <div class="w-full h-2.5 rounded-full bg-gray-100 overflow-hidden">
          <div
              class="h-full bg-emerald-500 rounded-full transition-all"
              :style="{ width: overallProgress.qty_percent + '%' }"
          ></div>
        </div>
      </div>

      <div class="space-y-1">
        <div class="flex items-center justify-between text-[8px] text-gray-600">
          <span>پیشرفت بر اساس مبلغ</span>
          <span>
        {{ fmt(summaryStats.delivered_value) }} / {{ fmt(summaryStats.planned_value) }}
        ({{ overallProgress.value_percent }}٪)
      </span>
        </div>
        <div class="w-full h-2.5 rounded-full bg-gray-100 overflow-hidden">
          <div
              class="h-full bg-emerald-600 rounded-full transition-all"
              :style="{ width: overallProgress.value_percent + '%' }"
          ></div>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-2 text-[8px]">
        <div class="p-2 rounded-xl bg-emerald-50 border border-emerald-100 space-y-1">
          <div class="flex items-center justify-between">
            <span class="text-emerald-700 font-semibold">تحویل‌شده</span>
            <span class="text-emerald-700 font-bold text-[10px]">
          {{ overallProgress.value_percent }}٪
        </span>
          </div>
          <div class="w-full h-1.5 bg-emerald-100 rounded-full overflow-hidden">
            <div
                class="h-full bg-emerald-500 rounded-full"
                :style="{ width: overallProgress.value_percent + '%' }"
            ></div>
          </div>
          <div class="flex justify-between text-[7px] text-emerald-800">
            <span>{{ fmt(summaryStats.delivered_value) }}</span>
            <span>{{ fmt(summaryStats.delivered_qty) }} عدد</span>
          </div>
        </div>

        <!-- مانده -->
        <div class="p-2 rounded-xl bg-amber-50 border border-amber-100 space-y-1">
          <div class="flex items-center justify-between">
            <span class="text-amber-700 font-semibold">مانده</span>
            <span class="text-amber-700 font-bold text-[10px]">
          {{ overallProgress.remaining_value_percent }}٪
        </span>
          </div>
          <div class="w-full h-1.5 bg-amber-100 rounded-full overflow-hidden">
            <div
                class="h-full bg-amber-400 rounded-full"
                :style="{ width: overallProgress.remaining_value_percent + '%' }"
            ></div>
          </div>
          <div class="flex justify-between text-[7px] text-amber-800">
            <span>{{ fmt(summaryStats.remaining_value) }}</span>
            <span>{{ fmt(summaryStats.remaining_qty) }} عدد</span>
          </div>
        </div>
      </div>

      <div class="space-y-1">
        <div class="flex items-center justify-between text-[8px] text-gray-600">
          <button
              @click="toggleItemsProgress"
              class="px-2 py-0.5 rounded-md text-[12px] border border-gray-300 text-gray-100 bg-blue-700 hover:bg-blue-900"
          >
            {{ showItemsProgress ? 'بستن لیست پیشرفت تحویل برای همهٔ ردیف‌ها' : 'نمایش پیشرفت تحویل برای همهٔ ردیف‌ها' }}
          </button>
        </div>

        <transition name="collapse">
          <div
              v-show="showItemsProgress"
              class="space-y-1 max-h-[35vh] overflow-auto pr-0.5"
          >
            <div
                v-for="it in sortedItems"
                :key="it.item_id"
                class="flex items-center gap-2"
            >
              <div
                  style="max-width: 50px; max-height: 50px"
                  class=" rounded-md bg-gray-100 border overflow-hidden flex items-center justify-center flex-shrink-0 cursor-pointer"
                  @click.stop="it.image && openImagePreview(img_source(it.image))"
              >
                <img
                    v-if="it.image"
                    style="max-width: 50px; max-height: 50px"
                    :src="img_source(it.image)"
                    class=" rounded-md object-cover"
                    alt=""
                />
                <span v-else class="text-[7px] text-gray-400">No IMAGE</span>
              </div>

              <!-- متن + پروگرس -->
              <div class="flex-1 min-w-0">
                <div class="flex justify-between items-center gap-2 text-[12px] text-gray-600">
                  <span class="truncate">
                    {{ it.sku || '-' }} - {{ it.name || '-' }}
                  </span>
                  <span class="text-[15px] text-gray-500">
                    {{
                      it.planned
                          ? Math.min(100, Math.round((it.delivered_to_date / it.planned) * 100))
                          : 0
                    }}٪
                  </span>
                </div>
                <div class="w-full h-1.5 mt-0.5 rounded-full bg-gray-100 overflow-hidden">
                  <div
                      class="h-full bg-emerald-500 rounded-full"
                      :style="{
                          width: (
                            it.planned
                              ? Math.min(100, Math.round((it.delivered_to_date / it.planned) * 100))
                              : 0
                          ) + '%'
                        }"
                  ></div>
                </div>
              </div>
            </div>

            <div
                v-if="!sortedItems.length"
                class="text-[8px] text-gray-400 text-center py-1"
            >
              آیتمی برای نمایش وجود ندارد.
            </div>
          </div>
        </transition>
      </div>
    </section>

    <div v-if="showSplitModal && splitTargetItem" class="fixed inset-0 z-[9998] flex items-center justify-center"
         @click.self="closeSplitModal">
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-[92vw] max-w-2xl p-4">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-sm font-semibold">تقسیم آیتم <span class=" text-gray-500">({{
              splitTargetItem.sku
            }})</span></h3>
          <button class="text-gray-500 hover:text-gray-700 text-sm" @click="closeSplitModal">بستن</button>
        </div>
        <div class="space-y-4">
          <div class="bg-gray-50 rounded-lg p-3 border border-gray-200">
            <div class="flex items-center gap-3">
              <img v-if="splitTargetItem.image" :src="img_source(splitTargetItem.image)"
                   class="w-12 h-12 rounded border object-cover"/>
              <div class="flex-1">
                <div class=" text-sm">{{ splitTargetItem.sku }}</div>
                <div class="text-xs text-gray-600">{{ splitTargetItem.name }}</div>
              </div>
              <div class="text-left">
                <div class="text-xs text-gray-500">تعداد کل:</div>
                <div class="font-bold text-sm">{{ splitTargetItem.planned }}</div>
              </div>
            </div>
          </div>

          <div class="space-y-3">
            <div class="flex items-center justify-between">
              <label class="text-xs font-medium text-gray-700">لیست تقسیم‌ها</label>
              <button type="button" class="px-2 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700"
                      @click="addSplitRow" :disabled="splitForm.splits.length >= 10">+ افزودن ردیف
              </button>
            </div>

            <div class="space-y-2 max-h-60 overflow-auto">
              <div v-for="(split, index) in splitForm.splits" :key="index"
                   class="flex items-center gap-2 p-3 border border-gray-200 rounded-lg">
                <div class="flex-1 grid grid-cols-1 md:grid-cols-3 gap-2">
                  <div>
                    <label class="block text-xs text-gray-600 mb-1">SKU</label>
                    <div class="flex gap-1">
                      <button
                          type="button"
                          class="px-3 py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600"
                          @click="generateSplitSku(index)"
                          title="تولید SKU تصادفی"
                      >
                        <span class="text-white">تولید</span>
                      </button>

                      <input type="text" v-model.trim="split.sku"
                             class="flex-1 px-2 py-1.5 text-xs border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                             placeholder="SKU جدید"/>
                    </div>
                  </div>
                  <div>
                    <label class="block text-xs text-gray-600 mb-1">نام</label>
                    <input type="text" v-model.trim="split.name"
                           class="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                           placeholder="نام جدید"/>
                  </div>
                  <div>
                    <label class="block text-xs text-gray-600 mb-1">تعداد</label>
                    <input type="number" v-model.number="split.total_quantity" min="1"
                           class="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-center"
                           placeholder="تعداد"/>
                  </div>
                </div>
                <button v-if="splitForm.splits.length > 1" type="button"
                        class="p-1 text-red-600 hover:text-red-700 hover:bg-red-50 rounded"
                        @click="removeSplitRow(index)" title="حذف ردیف">✕
                </button>
              </div>
            </div>

            <div class="flex items-center justify-between p-2 rounded border border-gray-200 bg-gray-50">
              <span class="text-xs text-gray-700">جمع تعداد:</span>
              <span class="text-sm font-bold text-gray-800">{{ totalSplitQuantity }}<span
                  class="text-xs text-gray-500 mr-1"> از {{ splitTargetItem.planned }}</span></span>
            </div>
          </div>
        </div>

        <div class="mt-6 flex items-center justify-end gap-2">
          <button class="px-4 py-2 text-xs bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                  @click="closeSplitModal">انصراف
          </button>
          <button
              class="px-4 py-2 text-xs bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
              :disabled="!canSubmitSplit || submittingSplit" @click="submitSplit">
            <span v-if="submittingSplit">در حال ثبت...</span>
            <span v-else>متغیر سازی</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Variation Modal -->
    <div v-if="showVarModal" class="fixed inset-0 z-[9998] flex items-center justify-center"
         @click.self="closeVarModal">
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-[92vw] max-w-xl p-4">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold">تغییر نوع محصول</h3>
          <button class="text-gray-500 hover:text-gray-700 text-sm" @click="closeVarModal">بستن</button>
        </div>
        <div class="space-y-4">
          <div class="rounded-lg ring-1 ring-gray-200 p-3 space-y-3 bg-gray-50">
            <div class="inline-flex rounded-md ring-1 ring-gray-200 overflow-hidden bg-white">
              <button type="button" class="px-3 py-1.5 text-xs"
                      :class="varForm.mode==='fk' ? 'bg-indigo-200 text-white' : 'text-gray-700 hover:bg-gray-50'"
                      @click="varForm.mode='fk'">متغیر کالای موجود
              </button>
              <button type="button" class="px-3 py-1.5 text-xs"
                      :class="varForm.mode==='manual' ? 'bg-indigo-200 text-white' : 'text-gray-700 hover:bg-gray-50'"
                      @click="varForm.mode='manual'">متغیر کالای جدید
              </button>
            </div>
            <div v-if="varForm.mode==='fk'" class="space-y-2">
              <label class="text-xs text-gray-700">انتخاب کالای موجود</label>
              <products-select product_type="variable,simple" v-model="varForm.product_id"></products-select>
            </div>
            <div v-else class="grid grid-cols-1 gap-3">
              <div>
                <label class="text-xs text-gray-700">نام کالای جدید</label>
                <input type="text" v-model.trim="varForm.variation_name"
                       class="w-full px-2 py-2 rounded-lg ring-1 ring-gray-200 focus:ring-emerald-400 text-sm"
                       placeholder="نام اولیه"/>
              </div>
            </div>
          </div>

          <div class="rounded-md bg-white ring-1 ring-gray-200 p-2"
               v-if="isBulkVar || (!isBulkVar && varTargetItems && varTargetItems.length)">
            <div class="text-xs text-gray-700 mb-2">اعمال روی <b>{{ isBulkVar ? selectedIds.length : 1 }}</b> مورد:
            </div>
            <div class="space-y-2 max-h-44 overflow-auto">
              <div v-for="it in varTargetItems" :key="it.item_id"
                   class="flex items-center gap-2 p-2 rounded border border-gray-200">
                <img v-if="it.image" :src="img_source(it.image)" class="w-8 h-8 rounded border object-cover"/>
                <div class="flex-1 min-w-0 ">
                  <div class="text-[11px] text-gray-800 truncate ">{{ it.sku || '-' }}</div>
                  <div class="text-[10px] text-gray-500 truncate">{{ it.name }}</div>
                </div>
                <button v-if="isBulkVar"
                        class="text-xs px-2 py-1 rounded bg-gray-100 ring-1 ring-gray-300 text-gray-700"
                        @click="removeFromSelection(it.item_id)">حذف
                </button>
              </div>
              <div v-if="isBulkVar && !varTargetItems.length" class="text-center text-xs text-gray-400 py-4">هیچ موردی
                انتخاب نشده.
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 flex items-center justify-end gap-2">
          <button class="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-700 text-xs" @click="closeVarModal">انصراف
          </button>
          <button class="px-3 py-1.5 rounded-lg bg-emerald-600 text-white text-xs disabled:bg-gray-400"
                  :disabled="!canSubmitVar" @click="submitVariation">ثبت
          </button>
        </div>
      </div>
    </div>
    <div v-if="showColorBulkModal" class="fixed inset-0 z-[9998] flex items-center justify-center"
         @click.self="closeBulkColorModal">
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-[92vw] max-w-xl p-4">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold">تغییر رنگ</h3>
          <button class="text-gray-500 hover:text-gray-700 text-sm" @click="closeBulkColorModal">بستن</button>
        </div>
        <div class="space-y-4">
          <category-tree-select
              label="انتخاب تغییر طیف رنگی"
              v-model="selectedColorId"
              :categories="color_spectrum"
              api-url="product/colorSpectrum"

          />

          <div class="rounded-md bg-white ring-1 ring-gray-200 p-2"
               v-if="isBulkColor || (!isBulkColor && selectedColorId && selectedColorId.length)">
            <div class="text-xs text-gray-700 mb-2">اعمال روی <b>{{ isBulkColor ? selectedIds.length : 1 }}</b> مورد:
            </div>
            <div class="space-y-2 max-h-44 overflow-auto">
              <div v-for="it in varTargetItems" :key="it.item_id"
                   class="flex items-center gap-2 p-2 rounded border border-gray-200">
                <img v-if="it.image" :src="img_source(it.image)" class="w-8 h-8 rounded border object-cover"/>
                <div class="flex-1 min-w-0 ">
                  <div class="text-[11px] text-gray-800 truncate ">{{ it.sku || '-' }}</div>
                  <div class="text-[10px] text-gray-500 truncate">{{ it.name }}</div>
                </div>
                <button v-if="isBulkVar"
                        class="text-xs px-2 py-1 rounded bg-gray-100 ring-1 ring-gray-300 text-gray-700"
                        @click="removeFromSelection(it.item_id)">حذف
                </button>
              </div>
              <div v-if="isBulkVar && !varTargetItems.length" class="text-center text-xs text-gray-400 py-4">هیچ موردی
                انتخاب نشده.
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 flex items-center justify-end gap-2">
          <button class="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-700 text-xs" @click="closeBulkColorModal">انصراف
          </button>
          <button class="px-3 py-1.5 rounded-lg bg-emerald-600 text-white text-xs disabled:bg-gray-400"
                  @click="submitBulkColor">ثبت
          </button>
        </div>
      </div>
    </div>

    <div
        v-if="showBulkProfitModal"
        class="fixed inset-0 z-[9998] flex items-center justify-center"
        @click.self="closeBulkProfitModal"
    >
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-[92vw] max-w-sm p-4">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold">تنظیم دسته‌جمعی حاشیه سود</h3>
          <button class="text-gray-500 hover:text-gray-700 text-xs" @click="closeBulkProfitModal">بستن</button>
        </div>

        <p class="text-[10px] text-gray-500 mb-3">
          این تنظیم روی
          <span v-if="selectionMode && selectedIds.length">
        <b>{{ selectedIds.length }}</b> آیتم انتخاب‌شده
      </span>
          <span v-else>
        <b>همه آیتم‌های پکیج</b>
      </span>
          اعمال می‌شود و قیمت نهایی هر کدام بر اساس قانون set_legend_pricing دوباره محاسبه خواهد شد.
        </p>

        <div class="space-y-3">
          <div>
            <label class="text-xs text-gray-700">نوع سود (profit_type)</label>
            <select
                v-model="bulkProfitForm.profit_type"
                class="w-full px-2 py-2 rounded-lg ring-1 ring-gray-200 text-sm"
            >
              <option value="percent">percent (درصدی)</option>
              <option value="amount">amount (مبلغ ثابت)</option>
            </select>
          </div>

          <div>
            <label class="text-xs text-gray-700">
              مقدار حاشیه سود (profit_margin)
            </label>
            <input
                v-model.number="bulkProfitForm.profit_margin"
                type="number"
                min="0"
                class="w-full px-2 py-2 rounded-lg ring-1 ring-gray-200 focus:ring-emerald-400 text-sm text-left"
                placeholder="مثلاً 30 یا 15000"
            />
          </div>
        </div>

        <div class="mt-4 flex items-center justify-end gap-2">
          <button
              class="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-700 text-xs"
              @click="closeBulkProfitModal"
              :disabled="savingBulkProfit"
          >
            انصراف
          </button>
          <button
              class="px-3 py-1.5 rounded-lg bg-emerald-600 text-white text-xs disabled:bg-gray-400"
              @click="submitBulkProfitChange"
              :disabled="savingBulkProfit || bulkProfitForm.profit_margin === null"
          >
            <span v-if="savingBulkProfit">در حال اعمال...</span>
            <span v-else>ثبت روی آیتم‌ها</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Bulk Minimum Inventory Modal -->
    <div v-if="showBulkMinInventoryModal" class="fixed inset-0 z-[9998] flex items-center justify-center"
         @click.self="closeBulkMinInventoryModal">
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-[92vw] max-w-md p-4">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold">تعیین حداقل موجودی گروهی</h3>
          <button class="text-gray-500 hover:text-gray-700 text-sm" @click="closeBulkMinInventoryModal">بستن</button>
        </div>
        <p class="text-xs text-gray-600 bg-cyan-50 p-3 rounded-lg border border-cyan-100 mb-3">
          حداقل موجودی فقط روی محصولاتی از این پکیج ست می‌شود که الان حداقل موجودیشان ۰ است (محصولاتی که از قبل مقدار دارند دست نمی‌خورند).
          تاریخ انقضا هم فقط روی محصولاتی از این پکیج ست می‌شود که الان تاریخ انقضا ندارند.
        </p>
        <div class="mb-3">
          <label class="text-xs text-gray-700">حداقل موجودی</label>
          <input v-model.number="bulkMinInventoryValue" type="number" min="0"
                 class="w-full px-2 py-2 rounded-lg ring-1 ring-gray-200 focus:ring-cyan-400 text-sm text-left"/>
        </div>
        <div>
          <label class="text-xs text-gray-700">تاریخ انقضا</label>
          <date-field v-model="bulkExpiredDate"/>
        </div>
        <div class="mt-4 flex items-center justify-end gap-2">
          <button class="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-700 text-xs"
                  @click="closeBulkMinInventoryModal" :disabled="savingBulkMinInventory">انصراف
          </button>
          <button class="px-3 py-1.5 rounded-lg bg-cyan-600 text-white text-xs disabled:bg-gray-400"
                  :disabled="savingBulkMinInventory || (bulkMinInventoryValue === null && !bulkExpiredDate)"
                  @click="submitBulkMinInventory">
            <span v-if="savingBulkMinInventory">در حال ذخیره...</span>
            <span v-else>ثبت روی همه آیتم‌ها</span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="showPriceModal && priceTargetItem" class="fixed inset-0 z-[9998] flex items-center justify-center"
         @click.self="closePriceModal">
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-[92vw] max-w-md p-4">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold">تغییر قیمت آیتم</h3>
          <button class="text-gray-500 hover:text-gray-700 text-sm" @click="closePriceModal">بستن</button>
        </div>
        <div class="grid grid-cols-1 gap-3">
          <div>
            <label class="text-xs text-gray-700">قیمت پایه (price)</label>
            <input v-model.number="priceForm.price" type="number" min="0"
                   class="w-full px-2 py-2 rounded-lg ring-1 ring-gray-200 focus:ring-emerald-400 text-sm text-left"/>
          </div>
          <div>
            <label class="text-xs text-gray-700">نوع سود (profit_type)</label>
            <select v-model="priceForm.profit_type" class="w-full px-2 py-2 rounded-lg ring-1 ring-gray-200 text-sm">
              <option value="percent">percent</option>
              <option value="amount">amount</option>
            </select>
          </div>
          <div>
            <label class="text-xs text-gray-700">حاشیه سود (profit_margin)</label>
            <input v-model.number="priceForm.profit_margin" type="number" min="0"
                   class="w-full px-2 py-2 rounded-lg ring-1 ring-gray-200 focus:ring-emerald-400 text-sm text-left"/>
          </div>
          <p class="text-[11px] text-gray-500">* بعد از ذخیره، سمت سرور set_legend_pricing اجرا و قیمت‌ها رند
            می‌شوند.</p>
        </div>
        <div class="mt-4 flex items-center justify-end gap-2">
          <button class="btn btn-secondary text-xs" @click="closePriceModal">انصراف</button>
          <button class="btn btn-primary text-xs" :disabled="saving.price" @click="submitPriceChange">ثبت قیمت</button>
        </div>
      </div>
    </div>

    <div v-if="showSimilarProductsModal && similarProductsTargetItem" class="fixed inset-0 z-[9998] flex items-center justify-center" @click.self="closeSimilarProductsModal">
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-[92vw] max-w-2xl p-4">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold">انتخاب محصول مشابه</h3>
          <button class="text-gray-500 hover:text-gray-700 text-xs" @click="closeSimilarProductsModal">✕</button>
        </div>

        <div class="mb-3 text-xs text-gray-600">
          <span>آیتم: </span>
          <span class="font-mono">{{ similarProductsTargetItem.sku || '-' }}</span>
          <span class="mr-2">{{ similarProductsTargetItem.name }}</span>
        </div>

        <div class="max-h-96 overflow-auto border border-gray-200 rounded-lg">
          <table class="min-w-full text-[10px]">
            <thead class="bg-gray-100 sticky top-0">
            <tr>
              <th class="px-2 py-1 text-center w-8">انتخاب</th>
              <th class="px-2 py-1 text-center">تصویر</th>
              <th class="px-2 py-1 text-right">کد ۱۶ رقمی</th>
              <th class="px-2 py-1 text-right">نام محصول</th>
              <th class="px-2 py-1 text-right">متغیر از</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="prod in similarProductsTargetItem.similar_product" :key="prod.id" class="border-t hover:bg-gray-50">
              <td class="px-2 py-1 text-center">
                <input type="radio" name="similarProduct" :value="prod.id" v-model="selectedSimilarProductId" class="cursor-pointer"/>
              </td>
              <td class="px-2 py-1 text-center">
                <div class="w-8 h-8 rounded bg-gray-100 border overflow-hidden mx-auto">
                  <img v-if="prod.image" :src="img_source(prod.image)" class="w-full h-full object-cover" @click.stop="openImagePreview(img_source(prod.image))"/>
                  <span v-else class="text-[6px] text-gray-400">بدون عکس</span>
                </div>
              </td>
              <td class="px-2 py-1 font-mono">{{ prod.sixteen_digit_code || '-' }}</td>
              <td class="px-2 py-1">{{ prod.name || '-' }}</td>
              <td class="px-2 py-1">{{ prod.variation_of_name || '-' }}</td>
            </tr>
            <tr v-if="!similarProductsTargetItem.similar_product || !similarProductsTargetItem.similar_product.length">
              <td colspan="5" class="px-2 py-3 text-center text-gray-400">
                محصول مشابهی یافت نشد
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="mt-4 flex items-center justify-end gap-2">
          <button class="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-700 text-xs" @click="closeSimilarProductsModal" :disabled="savingSimilarProduct">
            انصراف
          </button>
          <button
              class="px-3 py-1.5 rounded-lg bg-blue-600 text-white text-xs disabled:bg-gray-400"
              :disabled="!selectedSimilarProductId || savingSimilarProduct"
              @click="submitSimilarProduct"
          >
            <span v-if="savingSimilarProduct">در حال ثبت...</span>
            <span v-else>انتخاب</span>
          </button>
        </div>
      </div>
    </div>


    <div v-if="showColorModal && colorProductsTargetItem" class="fixed inset-0 z-[9998] flex items-center justify-center" @click.self="closeColorsModal">
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-[92vw] max-w-2xl">
        <div class="flex items-center justify-between mb-3 bg-blue-900 p-4 rounded-t-xl">
          <h3 class="text-sm font-semibold text-blue-50">انتخاب طیف رنگی</h3>
          <button class="text-gray-50 hover:text-red-400 text-xs" @click="closeColorsModal">✕</button>
        </div>

        <div class="mb-3 text-xs text-gray-600 p-4">
          <span>آیتم: </span>
          <span class="font-mono">{{ colorProductsTargetItem.sku || '-' }}</span>
          <span class="mr-2">{{ colorProductsTargetItem.name }}</span>
        </div>
        <div
            v-if="colorProductsTargetItem.color[0]"
            class="max-h-96 overflow-auto pa-2 ">
          رنگ فعلی :
           |
          <span
              v-for="color in colorProductsTargetItem.color"
              class="font-semibold "
          >
            {{color.name}}  |
          </span>
        </div>
        <div class="max-h-96 overflow-auto p-4" v-else>
          بدون رنگ
        </div>

        <div class="max-h-96 overflow-auto border border-gray-200 rounded-lg p-4">
          <category-tree-select
              :label="colorProductsTargetItem.color.id? 'تغییر انتخاب طیف رنگی' : 'انتخاب تغییر طیف رنگی'"
              v-model="selectedColorId"
              :categories="color_spectrum"
              api-url="product/colorSpectrum"

          />
        </div>

        <div class="mt-4 flex items-center justify-end gap-2 p-6">
          <button class="px-3 py-1.5 rounded-xl bg-gray-100 text-gray-700 text-xs" @click="closeColorsModal" >
            انصراف
          </button>
          <button
              class="px-3 py-1.5 rounded-xl bg-blue-600 text-white text-xs disabled:bg-gray-400"
              :disabled="!selectedColorId || savingColor"
              @click="submitColor"
          >
            <span v-if="savingColor">در حال ثبت...</span>
            <span v-else>انتخاب</span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="showImagePreview" class="fixed inset-0 z-[9999] flex items-center justify-center"
         @click.self="closeImagePreview">
      <div class="absolute inset-0 bg-black/70 backdrop-blur-sm"></div>
      <div class="relative max-w-[92vw] max-h-[88vh] p-2">
        <button class="absolute -top-3 -right-3 bg-white text-gray-700 rounded-full shadow px-2 py-1 text-xs"
                @click="closeImagePreview">✕
        </button>
        <img :src="imagePreviewSrc" alt="preview"
             class="block max-w-[92vw] max-h-[85vh] object-contain rounded-lg shadow-2xl" @click.stop/>
      </div>
    </div>
    <div v-if="showGenerateSkuConfirm" class="fixed inset-0 z-[9998] flex items-center justify-center"
         @click.self="closeGenerateSkuConfirm">
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-[92vw] max-w-md p-4">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold">تولید SKU برای آیتم‌های خالی</h3>
          <button class="text-gray-500 hover:text-gray-700 text-xs" @click="closeGenerateSkuConfirm">بستن</button>
        </div>

        <div class="space-y-3">
          <p class="text-sm text-gray-700">
            تعداد <b>{{ itemsWithoutSku.length }}</b> آیتم بدون SKU یافت شد.
          </p>

          <p class="text-xs text-gray-600 bg-blue-50 p-3 rounded-lg border border-blue-100">
            ✅ SKUهای ۱۳ رقمی با پیش‌شماره ۹۹۹۹ ساخته می‌شوند.<br>
            ⚠️ این عملیات غیرقابل بازگشت است.
          </p>

          <div class="max-h-60 overflow-auto border border-gray-200 rounded-lg">
            <table class="min-w-full text-[10px]">
              <thead class="bg-gray-100 sticky top-0">
              <tr>
                <th class="px-2 py-1 text-right">آیتم</th>
                <th class="px-2 py-1 text-center">نام</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="it in itemsWithoutSku.slice(0, 10)" :key="it.item_id" class="border-t">
                <td class="px-2 py-1 font-mono">{{ it.sku || '---' }}</td>
                <td class="px-2 py-1">{{ it.name || '---' }}</td>
              </tr>
              <tr v-if="itemsWithoutSku.length > 10">
                <td colspan="2" class="px-2 py-1 text-center text-gray-500">
                  و {{ itemsWithoutSku.length - 10 }} آیتم دیگر ...
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mt-4 flex items-center justify-end gap-2">
          <button
              class="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-700 text-xs"
              @click="closeGenerateSkuConfirm"
              :disabled="generatingSku"
          >
            انصراف
          </button>
          <button
              class="px-3 py-1.5 rounded-lg bg-blue-600 text-white text-xs disabled:bg-gray-400"
              @click="generateSkuForAllEmpty"
              :disabled="generatingSku"
          >
            <span v-if="generatingSku">در حال تولید و ذخیره...</span>
            <span v-else>تأیید و شروع</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductsSelect from '@/components/selects/ProductSelect'
import CleaveMoney from "@/components/mcomponents/cleave/Money";
import CategoryTreeSelect from "@/modules/product_admin/CategoryTreeSelect";
import DateField from "@/components/mcomponents/cleave/DateField";

export default {
  name: 'DomesticEntranceDashboard',
  components: {CategoryTreeSelect, CleaveMoney, ProductsSelect, DateField},
  props: {
    packageId: {type: [String, Number], required: true},
    basePath: {type: String, default: 'deliver/domestic-packages/'},
  },
  data() {
    return {
      color_spectrum: [],
      showSimilarProductsModal: false,
      similarProductsTargetItem: null,
      selectedSimilarProductId: null,
      savingSimilarProduct: false,
      showColorModal: false,
      colorProductsTargetItem: null,
      selectedColorId: [],
      savingColor: false,
      showGenerateSkuConfirm: false,
      itemsWithoutSku: [],
      generatingSku: false,
      generatedSku: '',
      itemStatsSkuSearch: '',
      showItemStats: false,
      showItemsProgress: false,
      showSummaryStats: false,
      showBulkProfitModal: false,
      showBulkMinInventoryModal: false,
      bulkMinInventoryValue: null,
      bulkExpiredDate: '',
      savingBulkMinInventory: false,
      showRemainingOnlyStats: false,
      showItems: false,
      bulkProfitForm: {
        profit_type: 'percent',
        profit_margin: null,
      },
      savingBulkProfit: false,
      showMeta: false,
      toasts: [],
      suppliers: [],
      currencies: [],
      meta: {
        title: '',
        factor_number: '',
        registration_date: '',
        supplier: null,
        explanation: '',
        cargo_cost_per_shipping: 0,
      },
      originalMeta: {},      items: [],
      loading: {meta: false, items: false},
      saving: {meta: false, price: false},
      skuSearch: '',
      selectionMode: false,
      selectedIds: [],
      showVarModal: false,
      showColorBulkModal: false,
      isBulkVar: false,
      isBulkColor: false,
      varForm: {mode: 'fk', product_id: null, variation_name: ''},
      showSplitModal: false,
      splitTargetItem: null,
      splitForm: {splits: [{sku: '', name: '', total_quantity: null}]},
      submittingSplit: false,
      showImagePreview: false,
      imagePreviewSrc: null,
      // inline edits
      editRow: {id: null, mode: null, newName: '', newSku: '', newPlanned: null, newRegularPrice: null, },
      // price modal
      showPriceModal: false,
      priceTargetItem: null,
      priceForm: {price: null, profit_type: 'percent', profit_margin: null},
      _debounce: null,
    }
  },
  computed: {
    itemsWithoutSkuCount() {
      return this.items.filter(it => !it.sku || it.sku.trim() === '').length;
    },
    orderedByRemaining() {
      const byRemain = (a, b) => {
        const ar = this.remainingEffective(a) > 0 ? 0 : 1
        const br = this.remainingEffective(b) > 0 ? 0 : 1
        if (ar !== br) return ar - br
        return Number(a?._order ?? 0) - Number(b?._order ?? 0)
      }
      return byRemain
    },
    itemsForStats() {
      const base = this.filteredStatsItems || []
      return [...base].sort(this.orderedByRemaining)
    },

    remainingOnlyStatsItems() {
      return (this.filteredStatsItems || []).filter(it => this.remainingEffective(it) > 0)
    },

    itemsForProgress() {
      const base = this.sortedItems || []
      return [...base].sort(this.orderedByRemaining)
    },
    filteredStatsItems() {
      const q = (this.itemStatsSkuSearch || '').toLowerCase().trim()
      const base = this.sortedItems
      if (!q) return base
      return base.filter(it =>
          (it.sku || '').toLowerCase().includes(q) ||
          (it.name || '').toLowerCase().includes(q) ||
          (it.variation_of_product_name || '').toLowerCase().includes(q)
      )
    },
    overallProgress() {
      const s = this.summaryStats || {
        planned_qty: 0,
        delivered_qty: 0,
        planned_value: 0,
        delivered_value: 0,
        remaining_value: 0,
      }

      const qty_percent = s.planned_qty > 0
          ? Math.round((s.delivered_qty / s.planned_qty) * 100)
          : 0

      const value_percent = s.planned_value > 0
          ? Math.round((s.delivered_value / s.planned_value) * 100)
          : 0

      const remaining_value_percent = s.planned_value > 0
          ? Math.round((s.remaining_value / s.planned_value) * 100)
          : 0

      return {
        qty_percent: Math.min(qty_percent, 100),
        value_percent: Math.min(value_percent, 100),
        remaining_value_percent: Math.min(remaining_value_percent, 100),
      }
    },
    summaryStats() {
      const s = {
        planned_qty: 0,
        delivered_qty: 0,
        returned_qty: 0,
        remaining_qty: 0,
        planned_value: 0,
        delivered_value: 0,
        returned_value: 0,
        remaining_value: 0,
      }

      for (const it of this.items) {
        const planned = Number(it.planned) || 0
        const delivered = Number(it.delivered_to_date) || 0
        const returned = Number(it.returned_quantity) || 0
        const base = Number(it.base_cost_before_profit || this.baseCost(it) || 0)

        const plannedEffective = Math.max(planned - returned, 0)
        const remainingEff = Math.max(plannedEffective - delivered, 0)

        s.planned_qty += planned
        s.delivered_qty += delivered
        s.returned_qty += returned
        s.remaining_qty += remainingEff

        s.planned_value += base * planned
        s.delivered_value += base * delivered
        s.returned_value += base * returned
        s.remaining_value += base * remainingEff
      }

      const delivered_percent =
          s.planned_value > 0 ? Math.round((s.delivered_value / s.planned_value) * 100) : 0

      return { ...s, delivered_percent }
    },

    current_currency() {
      if (this.meta.currency) return this.currencies.find(c => c.id === this.meta.currency) || {
        id: 0,
        name: 'تومان',
        exchange_rate_to_toman: 1
      }
      return {id: 0, name: 'تومان', exchange_rate_to_toman: 1}
    },

    metaDirty() {
      return JSON.stringify(this.meta) !== JSON.stringify(this.originalMeta)
    },
    isAllSelected() {
      const ids = this.sortedItems.map(x => x.item_id)
      return ids.length > 0 && ids.every(id => this.selectedIds.includes(id))
    },
    canSubmitVar() {
      if (this.varForm.mode === 'fk') return !!this.varForm.product_id
      return !!(this.varForm.variation_name && this.varForm.variation_name.trim())
    },
    varTargetItems() {
      const set = new Set(this.selectedIds)
      return this.items.filter(x => set.has(x.item_id))
    },
    totalSplitQuantity() {
      return this.splitForm.splits.reduce((s, x) => s + (Number(x.total_quantity) || 0), 0)
    },
    canSubmitSplit() {
      if (!this.splitTargetItem) return false
      return this.splitForm.splits.every(x => x.sku.trim() && x.name.trim() && Number(x.total_quantity) > 0)
    },
    filteredItems() {
      const q = (this.skuSearch || '').toLowerCase().trim()
      if (!q) return this.items
      const base = this.items
      if (!q) return base
      return base.filter(it =>
          (it.sku || '').toLowerCase().includes(q) ||
          (it.name || '').toLowerCase().includes(q) ||
          (it.variation_of_product_name || '').toLowerCase().includes(q)
      )

      return this.items.filter(i => (i.sku || '').toLowerCase().includes(q)) || this.items.filter(i => (i.name || '').toLowerCase().includes(q))
    },
    sortedItems() {
      const list = [...this.filteredItems];

      const isVar = (it) => it?.type === 'variation' && it.variation_of_product_id != null;
      const baseOrder = (it) => Number(it._order ?? 0);

      const groupFirstOrder = {};
      for (const it of list) {
        if (isVar(it)) {
          const gid = Number(it.variation_of_product_id);
          const ord = baseOrder(it);
          if (groupFirstOrder[gid] == null || ord < groupFirstOrder[gid]) {
            groupFirstOrder[gid] = ord;
          }
        }
      }
      return list.sort((a, b) => {
        const av = isVar(a), bv = isVar(b);
        if (av !== bv) return av ? -1 : 1;

        if (av && bv) {
          const ga = Number(a.variation_of_product_id);
          const gb = Number(b.variation_of_product_id);
          if (ga !== gb) return (groupFirstOrder[ga] ?? 0) - (groupFirstOrder[gb] ?? 0);
          return baseOrder(a) - baseOrder(b);
        }

        return baseOrder(a) - baseOrder(b);
      });
    },
  },
  created() {
    this.loadMeta();
    this.loadItems();
    this.fetchSuppliers();
    this.fetchCurrencies();
    this.fetchColorSpectrum();

  },
  methods: {
    fetchColorSpectrum() {
      this.request({
        url: this.endpoint("product/colorSpectrumTree"),
        method: "get",
        success: (d) => { this.color_spectrum = d || []; },
      });
    },

    openSimilarProductsModal(it) {
      this.similarProductsTargetItem = it;
      this.selectedSimilarProductId = null;
      this.showSimilarProductsModal = true;
    },

    closeSimilarProductsModal() {
      if (this.savingSimilarProduct) return;
      this.showSimilarProductsModal = false;
      this.similarProductsTargetItem = null;
      this.selectedSimilarProductId = null;
    },

    async submitSimilarProduct() {
      if (!this.selectedSimilarProductId || !this.similarProductsTargetItem) return;

      this.savingSimilarProduct = true;
      try {
        await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/items/change-product`),
          method: 'post',
          data: {
            item_id: this.similarProductsTargetItem.item_id,
            product_id: this.selectedSimilarProductId
          }
        });

        this.showNotif('محصول با موفقیت انتخاب شد ✅');
        this.closeSimilarProductsModal();
        await this.loadItems();
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در انتخاب محصول', 'error', 4500);
      } finally {
        this.savingSimilarProduct = false;
      }
      this.loadItems();
      this.closeSimilarProductsModal()
    },
    openColorModal(it) {
      this.colorProductsTargetItem = it;
      this.selectedColorId = it.color;
      this.showColorModal = true;
    },

    closeColorsModal() {
      if (this.savingColor) return;
      this.colorProductsTargetItem = null;
      this.selectedColorId = [];
      this.showColorModal = false;
      this.savingColor = false
    },

    async submitColor() {
      this.savingColor = true;
      let color_ids = []
      for(let co of this.selectedColorId) {
        color_ids.push(co.id)
      }
      try {
        await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/items/change-color`),
          method: 'post',
          data: {
            item_id: this.colorProductsTargetItem.item_id,
            color_id: color_ids
          }
        });

        this.showNotif('رنگ با موفقیت انتخاب شد ✅');
        this.closeColorsModal();

        this.closeColorsModal();
        await this.loadItems();
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در انتخاب محصول', 'error', 4500);
      } finally {
        this.savingColor = false;
      }
      this.closeColorsModal();
      this.loadItems();
    },
    async submitBulkColor() {
      this.savingColor = true;
      let color_ids = []
      for(let co of this.selectedColorId) {
        color_ids.push(co.id)
      }
      try {
        await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/items/change-color-bulk`),
          method: 'post',
          data: {
            item_id: this.selectedIds,
            color_id: color_ids
          }
        });

        this.showNotif('رنگ با موفقیت انتخاب شد ✅');
        this.closeBulkColorModal();

        await this.loadItems();
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در انتخاب محصول', 'error', 4500);
      } finally {
        this.savingColor = false;
      }
      this.closeBulkColorModal();
      this.selectionMode = false
      this.selectedIds = []
      this.selectedColorId = []
      this.loadItems();
    },

    generateSplitSku(index) {
      const randomPart = Math.floor(Math.random() * 1000000000).toString().padStart(9, '0');
      const newSku = '9999' + randomPart;

      if (this.splitForm.splits[index]) {
        this.splitForm.splits[index].sku = newSku;
      }
    },

    // متد باز کردن مودال تایید برای آیتم‌های خالی
    openGenerateSkuConfirm() {
      this.itemsWithoutSku = this.items.filter(it => !it.sku || it.sku.trim() === '');
      if (this.itemsWithoutSku.length === 0) {
        this.showNotif('همه آیتم‌ها قبلاً SKU دارند.', 'error', 3000);
        return;
      }
      this.showGenerateSkuConfirm = true;
    },

    closeGenerateSkuConfirm() {
      if (this.generatingSku) return;
      this.showGenerateSkuConfirm = false;
      this.itemsWithoutSku = [];
    },

    async generateSkuForAllEmpty() {
      if (this.generatingSku) return;

      this.generatingSku = true;
      const itemsToUpdate = this.itemsWithoutSku;
      let successCount = 0;
      const errors = [];

      try {
        for (const it of itemsToUpdate) {
          try {
            const randomPart = Math.floor(Math.random() * 1000000000).toString().padStart(9, '0');
            const newSku = '9999' + randomPart;

            await this.requestAsync({
              url: this.endpoint(`${this.basePath}${this.packageId}/items/change-sku`),
              method: 'post',
              data: {
                item_id: it.item_id,
                new_sku: newSku
              }
            });

            const index = this.items.findIndex(x => x.item_id === it.item_id);
            if (index !== -1) {
              this.items[index].sku = newSku;
            }

            successCount++;
          } catch (e) {
            errors.push(`آیتم ${it.name || it.sku || it.item_id}: ${this.extractErr(e)}`);
          }
        }

        if (errors.length === 0) {
          this.showNotif(`${successCount} آیتم با موفقیت بروزرسانی شدند ✅`, 'success', 4000);
          this.closeGenerateSkuConfirm();
        } else {
          this.showNotif(`${successCount} آیتم بروزرسانی شد، ${errors.length} خطا داشت.`, 'error', 6000);
          console.error('خطاهای تولید SKU:', errors);
        }

        await this.loadItems();

      } catch (e) {
        this.showNotif('خطا در تولید دسته‌جمعی SKU', 'error', 4000);
      } finally {
        this.showGenerateSkuConfirm = false;
        this.generatingSku = false;
      }
    },

    // متد تولید SKU برای ویرایش inline
    generateSku() {
      const randomPart = Math.floor(Math.random() * 1000000000).toString().padStart(9, '0');
      this.generatedSku = '9999' + randomPart;

      if (this.editRow.mode === 'sku') {
        this.editRow.newSku = this.generatedSku;
      }
    },



    async markRemainingAsReturned(it) {
      if (!it || !it.item_id) return

      if (this.remainingEffective(it) <= 0) {
        this.showNotif('برای این آیتم چیزی برای مرجوعی باقی نمانده.', 'error', 2500)
        return
      }

      if (!confirm(`تمام ماندهٔ آیتم «${it.sku || it.name || ''}» به عنوان مرجوعی ثبت شود؟`)) {
        return
      }

      try {
        const res = await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/items/mark-remaining-returned`),
          method: 'post',
          data: { item_id: it.item_id },
        })

        it.returned_quantity = res.returned_quantity
        it.planned = res.total_quantity
        it.delivered_to_date = res.delivered_to_date
        if (res.remaining_effective != null) {
          it.remaining = res.remaining_effective
        }

        this.showNotif('ماندهٔ آیتم به عنوان مرجوعی ثبت شد ✅')
        await this.loadItems()
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در ثبت مرجوعی مانده', 'error', 4500)
      }
    },

    remainingEffective(it) {
      const planned = Number(it?.planned || 0)
      const delivered = Number(it?.delivered_to_date || 0)
      const returned = Number(it?.returned_quantity || 0)

      const plannedEffective = Math.max(planned - returned, 0)
      return Math.max(plannedEffective - delivered, 0)
    },
    returnedQty(it) {
      return Number(it?.returned_quantity || 0)
    },

    isVariation(it){
      return it && it.type === 'variation' && it.variation_of_product_id != null;
    },

    rowStyle(it, idx) {
      const s = {};

      if (it && this.isVariation(it)) {
        const done = this.isDone(it);
        const key = String(it.variation_of_product_id || '');
        const hBase = this.hashCode(key);

        if (done) {
          const hue = 120 + (hBase % 40);
          s.backgroundColor = `hsl(${hue} 55% 88%)`;
        } else {
          let hue = (hBase * 37) % 360;
          if (hue >= 90 && hue <= 170) hue = (hue + 80) % 360;
          s.backgroundColor = `hsl(${hue} 70% 92%)`;
        }
      }

      const hasPrev = idx > 0;
      const hasNext = idx < this.sortedItems.length - 1;

      if (this.isGroupStart(idx) && hasPrev) {
        s.borderTop = '50px solid rgba(255,255,255)';
      }
      if (this.isGroupEnd(idx) && hasNext) {
        s.borderBottom = '50px solid rgba(255,255,255)';
      }

      return s;
    },
    groupColorIndex(it) {
      const id = Number(it?.variation_of_product_id || 0);
      return Math.abs(id) % 6;
    },
    hashCode(str) {
      let h = 0;
      for (let i = 0; i < str.length; i++) {
        h = (h << 5) - h + str.charCodeAt(i);
        h |= 0;
      }
      return Math.abs(h);
    },
    groupKey(it) {
      if (!this.isVariation(it)) return null;
      return `V-${String(it.variation_of_product_id)}`;
    },
    isSameGroup(a, b) {
      if (!a || !b) return false;
      const ka = this.groupKey(a), kb = this.groupKey(b);
      return !!ka && ka === kb;
    },

    isGroupStart(idx) {
      const cur = this.sortedItems[idx];
      const prev = this.sortedItems[idx - 1];
      const ck = this.groupKey(cur);
      const pk = prev ? this.groupKey(prev) : null;
      return ck && ck !== pk;
    },
    isGroupEnd(idx) {
      const cur = this.sortedItems[idx];
      const next = this.sortedItems[idx + 1];
      const ck = this.groupKey(cur);
      const nk = next ? this.groupKey(next) : null;
      return ck && ck !== nk;
    },

    groupBgClass(it) {
      const key = this.groupKey(it);
      if (!key) return '';
      const idx = this.groupColorIndex(key);
      return `group-bg-${idx}`;
    },

    rowClasses(it, idx) {
      const classes = [];

      const done = this.isDone(it);

      if (done) {
        if (this.isVariation(it)) {
          const gi = this.groupColorIndex(it);
          classes.push(`bg-done-var-${gi}`, 'row-done');
        } else {
          classes.push('bg-done-simple', 'row-done');
        }
      } else {
        if (this.isVariation(it)) {
          const gi = this.groupColorIndex(it);
          classes.push(`bg-open-var-${gi}`, 'row-open-var');
        } else {
        }
      }

    },
    isDone(it) {
      return this.remainingEffective(it) <= 0
    },

    toggleItemsProgress() {
      this.showItemsProgress = !this.showItemsProgress
    },
    toggleItemStatsCollapse() {
      this.showItemStats = !this.showItemStats
      if (!this.showItemStats) {
        this.itemStatsSkuSearch = ''
      }
    },
    baseCost(it) {
      return (
          (Number(it.price) || 0)
      )
    },
    toggleItemsCollapse() {
      this.showItems = !this.showItems
      if (!this.showItems) {
        this.selectionMode = false
        this.selectedIds = []
        this.resetEdit()
      } else {
        if (!this.items.length && !this.loading.items) {
          this.loadItems()
        }
      }
    },
    closeVarModal() {
      this.showVarModal = false
      this.isBulkVar = false

      this.varForm = {
        mode: 'fk',
        product_id: null,
        variation_name: '',
      }

      if (!this.selectedIds.length) {
        this.selectionMode = false
      }
    },
    closeBulkColorModal() {
      this.showColorBulkModal = false
      this.isBulkColor = false
      if (!this.selectedIds.length) {
        this.selectionMode = false
      }
    },

    openBulkProfitModal() {
      this.bulkProfitForm = {
        profit_type: 'percent',
        profit_margin: null,
      }
      this.showItems = true
      this.showBulkProfitModal = true
    },

    closeBulkProfitModal() {
      if (this.savingBulkProfit) return
      this.showBulkProfitModal = false
    },

    async submitBulkProfitChange() {
      if (this.savingBulkProfit) return

      const margin = Number(this.bulkProfitForm.profit_margin)
      if (isNaN(margin) || margin < 0) {
        this.showNotif('حاشیه سود معتبر نیست.', 'error', 3000)
        return
      }

      const payload = {
        profit_type: this.bulkProfitForm.profit_type,
        profit_margin: margin,
      }

      if (this.selectionMode && this.selectedIds.length) {
        payload.item_ids = [...this.selectedIds]
      }

      this.savingBulkProfit = true
      try {
        const res = await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/items/bulk-profit`),
          method: 'post',
          data: payload,
        })

        const count = res?.updated_count ?? (res?.item_ids?.length || 0)
        this.showNotif(`سود ${count} آیتم به‌روزرسانی شد ✅`)
        this.showBulkProfitModal = false
        this.toggleSelectionMode(false)
        await this.loadItems()
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در تنظیم دسته‌جمعی سود', 'error', 4500)
      } finally {
        this.savingBulkProfit = false
      }
    },

    // --- Bulk minimum inventory ---
    openBulkMinInventoryModal() {
      this.bulkMinInventoryValue = null
      this.bulkExpiredDate = ''
      this.showBulkMinInventoryModal = true
    },
    closeBulkMinInventoryModal() {
      if (this.savingBulkMinInventory) return;
      this.showBulkMinInventoryModal = false;
    },
    async submitBulkMinInventory() {
      if (this.bulkMinInventoryValue === null && !this.bulkExpiredDate) return
      this.savingBulkMinInventory = true
      try {
        const payload = {}
        if (this.bulkMinInventoryValue !== null) payload.minimum_inventory = Number(this.bulkMinInventoryValue || 0)
        if (this.bulkExpiredDate) payload.expired_date = this.bulkExpiredDate
        const res = await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/items/bulk-min-inventory`),
          method: 'post',
          data: payload
        })
        const parts = []
        if (payload.minimum_inventory !== undefined) parts.push(`حداقل موجودی ${res.min_inventory_updated_count} محصول`)
        if (payload.expired_date !== undefined) parts.push(`تاریخ انقضای ${res.expired_date_updated_count} محصول`)
        this.showNotif(`${parts.join(' و ')} ثبت شد ✅`)
        this.showBulkMinInventoryModal = false
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در تعیین حداقل موجودی گروهی', 'error', 4500)
      } finally {
        this.savingBulkMinInventory = false
      }
    },

    showNotif(message, type = 'success', timeout = 2200) {
      const id = Math.random().toString(36).slice(2)
      this.toasts.push({id, message, type})
      if (timeout) {
        setTimeout(() => this.removeToast(id), timeout)
      }
    },
    removeToast(id) {
      this.toasts = this.toasts.filter(t => t.id !== id)
    },
    openImagePreview(src) {
      if (!src) return;
      this.imagePreviewSrc = src;
      this.showImagePreview = true
    },
    closeImagePreview() {
      this.showImagePreview = false;
      this.imagePreviewSrc = null
    },
    fmt(v) {
      if (v == null) return '-';
      return Number(v).toLocaleString('fa-IR')
    },

    // --- Request wrappers (expect global this.request / this.endpoint) ---
    requestAsync(opts) {
      return new Promise((resolve, reject) => {
        this.request({
          ...opts, success: (res) => {
            const status = res?.status ?? res?.response?.status;
            const errLike = (typeof status === 'number' && status >= 400) || res?.ok === false || res?.error || res?.errors;
            if (errLike) return reject(res);
            resolve(res)
          }, error: (e) => reject(e)
        })
      })
    },
    endpoint(path) {
      return this.$parent?.endpoint ? this.$parent.endpoint(path) : path
    },

    // --- Data loading ---
    async loadMeta() {
      this.loading.meta = true
      try {
        const data = await this.requestAsync({url: this.endpoint(`${this.basePath}${this.packageId}`), method: 'get'})
        const m = data || {}
        this.meta = {
          title: m.title || '',
          factor_number: m.factor_number || '',
          registration_date: m.registration_date || '',
          supplier: m.supplier_id || null,
          explanation: m.explanation || '',
          cargo_cost_per_shipping: m.cargo_cost_per_shipping ?? 0,
        }
        this.originalMeta = JSON.parse(JSON.stringify(this.meta))
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در دریافت اطلاعات پکیج', 'error', 4000)
      } finally {
        this.loading.meta = false
      }
    },
    async loadItems() {
      this.loading.items = true
      try {
        const data = await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/items`),
          method: 'get'
        })
        this.items = Array.isArray(data) ? data : []
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در دریافت آیتم‌ها', 'error', 4000)
      } finally {
        this.loading.items = false
      }
    },
    async fetchSuppliers() {
      try {
        const d = await this.requestAsync({url: this.endpoint('main/supplier'), method: 'get'});
        this.suppliers = Array.isArray(d) ? d : []
      } catch (_) {
      }
    },
    async fetchCurrencies() {
      try {
        const d = await this.requestAsync({url: this.endpoint('main/currency'), method: 'get'});
        this.currencies = Array.isArray(d) ? d : []
      } catch (_) {
      }
    },
    reloadAll() {
      this.loadMeta();
      this.loadItems()
    },

    async saveMeta() {
      if (this.saving.meta) return
      this.saving.meta = true
      try {
        const payload = { ...this.meta }
        await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/update-meta`),
          method: 'patch',
          data: payload,
        })
        this.showNotif('تغییرات پکیج ثبت شد')
        await this.loadItems()
        this.originalMeta = JSON.parse(JSON.stringify(this.meta))
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در ثبت تغییرات پکیج', 'error', 4500)
      } finally {
        this.saving.meta = false
      }
    },

    // --- Selection & variation ---
    toggleSelectionMode(on) {
      this.showItems = true
      this.selectionMode = on;
      if (!on) this.selectedIds = []
    },
    toggleSelectAll(e) {
      if (e.target.checked) {
        this.selectedIds = this.sortedItems.map(x => x.item_id)
      } else {
        this.selectedIds = []
      }
    },
    removeFromSelection(id) {
      this.selectedIds = this.selectedIds.filter(x => x !== id)
    },
    selectItemTypeForChange(it) {
      this.toggleSelectionMode(true);
      if (!this.selectedIds.includes(it.item_id)) this.selectedIds.push(it.item_id);
      this.openVariationModalBulk()
    },
    openVariationModalBulk() {
      this.isBulkVar = true;
      this.showItems = true;
      this.varForm = {mode: 'fk', product_id: null, variation_name: ''};
      this.showVarModal = true
    },
    openColorModalBulk() {
      this.isBulkColor = true;
      this.showItems = true;
      this.showColorBulkModal = true
    },
    async submitColors() {
      try {
        if (this.isBulkColor) {
          const base = (this.varForm.mode === 'fk') ? {
            type: 'variation',
            variation_of_product_id: this.varForm.product_id
          } : {type: 'variation', variation_name: this.varForm.variation_name}
          const items = this.selectedIds.map(id => ({item_id: id, ...base}))
          await this.requestAsync({
            url: this.endpoint(`${this.basePath}${this.packageId}/items/set-variation-bulk`),
            method: 'post',
            data: {items}
          })
        }
        this.toggleSelectionMode(false)
        this.showVarModal = false
        this.showNotif('نوع آیتم‌ها به‌روزرسانی شد')
        await this.loadItems()
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در ثبت تغییر نوع', 'error', 4500)
      }
    },

    async submitVariation() {
      if (!this.canSubmitVar) return
      try {
        if (this.isBulkVar) {
          const base = (this.varForm.mode === 'fk') ? {
            type: 'variation',
            variation_of_product_id: this.varForm.product_id
          } : {type: 'variation', variation_name: this.varForm.variation_name}
          const items = this.selectedIds.map(id => ({item_id: id, ...base}))
          await this.requestAsync({
            url: this.endpoint(`${this.basePath}${this.packageId}/items/set-variation-bulk`),
            method: 'post',
            data: {items}
          })
        }
        this.toggleSelectionMode(false)
        this.showVarModal = false
        this.showNotif('نوع آیتم‌ها به‌روزرسانی شد')
        await this.loadItems()
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در ثبت تغییر نوع', 'error', 4500)
      }
    },

    // --- Split ---
    openSplitModal(it) {
      this.splitTargetItem = it;
      this.splitForm = {splits: [{sku: '', name: '', total_quantity: null}]};
      this.showSplitModal = true
    },
    closeSplitModal() {
      this.showSplitModal = false;
      this.splitTargetItem = null
    },
    addSplitRow() {
      if (this.splitForm.splits.length < 10) this.splitForm.splits.push({sku: '', name: '', total_quantity: null})
    },
    removeSplitRow(i) {
      if (this.splitForm.splits.length > 1) this.splitForm.splits.splice(i, 1)
    },
    async submitSplit() {
      if (!this.canSubmitSplit || !this.splitTargetItem) return
      this.submittingSplit = true
      try {
        const payload = {
          item_id: this.splitTargetItem.item_id,
          splits: this.splitForm.splits.map(s => ({sku: s.sku, name: s.name, total_quantity: Number(s.total_quantity)}))
        }
        await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/items/split`),
          method: 'post',
          data: payload
        })
        this.showNotif('تقسیم آیتم انجام شد')
        this.closeSplitModal();
        await this.loadItems()
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در تقسیم آیتم', 'error', 4500)
      } finally {
        this.submittingSplit = false
      }
    },

    // --- Inline edits ---
    beginEditName(it) {
      this.editRow = {id: it.item_id, mode: 'name', newName: it.name, newSku: '', newPlanned: null}
    },
    beginEditSku(it) {
      this.editRow = {id: it.item_id, mode: 'sku', newSku: it.sku || '', newName: '', newPlanned: null}
    },
    beginEditPlanned(it) {
      this.editRow = {id: it.item_id, mode: 'planned', newPlanned: it.planned, newName: '', newSku: ''}
    },
    beginEditRegular(it) {
      this.editRow = {id: it.item_id, mode: 'regular', newRegularPrice: it.regular_price, newName: '', newSku: ''}
    },
    resetEdit() {
      this.editRow = {id: null, mode: null, newName: '', newSku: '', newPlanned: null}
    },

    async commitName(it) {
      try {
        const payload = {item_id: it.item_id, new_name: (this.editRow.newName || '').trim()}
        const res = await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/items/change-name`),
          method: 'post',
          data: payload
        })
        it.name = res.new_name;
        this.showNotif('نام آیتم تغییر کرد');
        this.resetEdit()
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در تغییر نام', 'error', 4000)
      }
    },
    async commitSku(it) {
      try {
        const payload = {item_id: it.item_id, new_sku: (this.editRow.newSku || '').trim()}
        const res = await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/items/change-sku`),
          method: 'post',
          data: payload
        })
        it.sku = res.sku;
        this.showNotif('SKU تغییر کرد');
        this.resetEdit()
        this.skuSearch = ''
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در تغییر SKU', 'error', 4000)
      }
    },
    async commitPlanned(it) {
      try {
        const payload = {item_id: it.item_id, new_planned: Number(this.editRow.newPlanned || 0)}
        const res = await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/items/change-planned`),
          method: 'post',
          data: payload
        })
        it.planned = res.total_quantity;
        this.showNotif('تعداد کل تغییر کرد');
        this.resetEdit()
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در تغییر تعداد', 'error', 4000)
      }
    },
    async commitRegular(it) {
      try {
        const payload = {item_id: it.item_id, new_regular_price: Number(this.editRow.newRegularPrice || 0)}
        const res = await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/items/change-regular`),
          method: 'post',
          data: payload
        })
        it.regular_price = res.regular_price;
        this.showNotif('قیمت مصرف تغییر کرد');
        this.resetEdit()
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در تغییر قیمت مصرف', 'error', 4000)
      }
    },

    openPriceModal(it) {
      this.priceTargetItem = it
      this.priceForm = {
        price: it.price ?? null,
        profit_type: it.profit_type || 'percent',
        profit_margin: it.profit_margin ?? 0,
        shipping_price: it.shipping_price ?? 0,
      }
      this.showPriceModal = true
    },
    closePriceModal() {
      this.showPriceModal = false;
      this.priceTargetItem = null
    },
    async submitPriceChange() {
      if (!this.priceTargetItem) return
      this.saving.price = true
      try {
        const payload = {
          item_id: this.priceTargetItem.item_id,
          price: Number(this.priceForm.price || 0),
          profit_type: this.priceForm.profit_type,
          profit_margin: Number(this.priceForm.profit_margin || 0),
          shipping_price: Number(this.priceForm.shipping_price || 0),
        }
        const res = await this.requestAsync({
          url: this.endpoint(`${this.basePath}${this.packageId}/items/change-price`),
          method: 'post',
          data: payload,
        })
        this.showNotif('قیمت آیتم به‌روزرسانی شد')
        this.closePriceModal()
        await this.loadItems()
      } catch (e) {
        this.showNotif(this.extractErr(e) || 'خطا در تغییر قیمت', 'error', 4500)
      } finally {
        this.saving.price = false
      }
    },
    // --- Misc ---
    debouncedLoadItems() {
      clearTimeout(this._debounce);
      this._debounce = setTimeout(() => this.loadItems(), 200)
    },
    extractErr(e) {
      try {
        const d = e?.response?.data || e
        if (typeof d === 'string') return d
        if (Array.isArray(d) && d.length) return d[0]?.messages?.[0]
        if (d?.detail) return d.detail
        if (d && typeof d === 'object') return Object.keys(d).map(k => `${k}: ${Array.isArray(d[k]) ? d[k].join(', ') : d[k]}`).join(' | ')
        return e?.message || 'خطای نامشخص'
      } catch (_) {
        return 'خطای نامشخص'
      }
    },
  }
}
</script>

<style scoped>
.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.18s ease;
}

.collapse-enter-from,
.collapse-leave-to {
  max-height: 0;
  opacity: 0;
}

.collapse-enter-to,
.collapse-leave-from {
  max-height: 600px;
  opacity: 1;
}

.btn {
  @apply inline-flex items-center justify-center rounded-xl px-3 py-2 text-sm font-medium border;
}

.btn-primary {
  @apply bg-emerald-600 text-white border-emerald-600 hover:bg-emerald-700;
}

.btn-secondary {
  @apply bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-200;
}

.th {
  @apply px-4 py-2 text-center text-[5px] uppercase tracking-wider;
}

.td {
  @apply px-4 py-2 items-center text-center justify-center;
}

.toast-enter-active, .toast-leave-active {
  transition: all .18s ease;
}

.toast-enter-from, .toast-leave-to {
  opacity: 0;
  transform: translateY(-6px) scale(.98);
}
.collapse-enter-active,
.collapse-leave-active {
  transition: all .18s ease;
}
.collapse-enter-from,
.collapse-leave-to {
  max-height: 0;
  opacity: 0;
}
.collapse-enter-to,
.collapse-leave-from {
  max-height: 800px;
  opacity: 1;
}
</style>
